var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShip = function SvgShip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.112 11.208h-4.999c-.883 0-1.594.693-1.594 1.554v10.334l15.512-7.246 15.512 7.246V12.762c0-.86-.71-1.554-1.594-1.554H17.112Zm17.882-1.554v-.945c0-.862-.711-1.555-1.595-1.555h-3.856L28.853 1H23.21l-.69 6.154h-3.856c-.883 0-1.573.693-1.573 1.555v.945h17.904Zm-8.941 7.897L3 28.326l6.83 19.408c3.167-1.428 7.239-2.772 11.418-2.772 6.7 0 12.108 3.108 19.175 4.705h1.163l7.52-21.34L26.052 17.55Z"
  })));
};

export default SvgShip;